/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import { connect } from "react-redux";
import { notify } from "../../reducers/NotifierReducer";

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null, errorInfo: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		this.setState({ error, errorInfo });
		if (!this.props.isDialog) {
			this.props.notify(
				"Something went wrong. If the issue persists, contact support.",
				"error"
			);
		} else {
			sessionStorage.setItem(
				"errorBoundMsg",
				"Something went wrong. If the issue persists, contact support."
			);
		}
		setTimeout(() => {
			this.props.onError();
		}, 100);
	}

	componentDidMount() {
		const errorMsg = sessionStorage.getItem("errorBoundMsg");
		if (errorMsg) {
			this.props.notify(errorMsg, "error");
			sessionStorage.removeItem("errorBoundMsg");
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location && this.state.hasError) {
			this.setState({ hasError: false, error: null, errorInfo: null });
		}
	}

	render() {
		return this.state.hasError && !this.props.isDialog
			? null
			: this.props.children;
	}
}

export default connect(null, {
	notify,
})(ErrorBoundary);
